import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { isNumber } from '~/lib/math';
import { useUser } from '~/providers/user';
import Permissions from '~/settings/permissions';
import { useGrid } from '../../../provider';
import CellTabs from '../cell_tabs';
import checklistValues from './checklistValues';
import DetailsModal from './details_modal';
import clauseValues from './valueGetters';
const ClauseCell = (props) => {
    const { cellId, rowIndex, descriptor, doc, clauseData, } = props;
    const { hasPermission } = useUser();
    const { anchorDoc, selectedRowIndex, setSelectedRowIndex, areCommentsVisible, areChecklistItemsVisible, modalDocument, isDocModalOpen, setModalDocument, setIsDocModalOpen, setDocBookmark, anchorDocTabIndex, setAnchorDocTabIndex, } = useGrid();
    const [clauseIndex, setClauseIndex] = useState(0);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedQuestion, setSelectedQuestion] = useState();
    const isActiveRow = selectedRowIndex === rowIndex;
    const clauseSources = (clauseData === null || clauseData === void 0 ? void 0 : clauseData.sources) || [];
    const clauseSource = clauseData === null || clauseData === void 0 ? void 0 : clauseData.sources.at(clauseIndex);
    useEffect(() => {
        setClauseIndex(0);
    }, [anchorDoc]);
    useEffect(() => {
        if (isDocModalOpen) {
            setIsModalVisible(false);
            setSelectedQuestion(undefined);
        }
    }, [isDocModalOpen]);
    const getCellValueFormatted = () => {
        return clauseValues.cellValueFormatted(clauseSource);
    };
    const getModalValueFormatted = () => {
        return clauseValues.modalValueFormatted(clauseSource);
    };
    const docModalNavigate = () => {
        if (!clauseSource)
            return;
        if (!clauseSource.pageNumber || !clauseSource.coordinates)
            return;
        if ((modalDocument === null || modalDocument === void 0 ? void 0 : modalDocument.fileId) !== doc.fileId)
            setModalDocument(doc);
        setDocBookmark([{ annotations: [{
                        pageNum: Number(clauseSource.pageNumber),
                        coordinates: clauseSource.coordinates,
                        confidenceScore: clauseSource.confidenceScore,
                    }] }]);
        setIsDocModalOpen(true);
    };
    const confScore = clauseSource ? clauseSource.confidenceScore : 100;
    const rowClass = classnames('classification cell', {
        active: isActiveRow,
        'comments-visible': areCommentsVisible,
        'low-confidence': isActiveRow
            ? confScore && isNumber(confScore) && Number(confScore) < 65
            : clauseSources.some(c => (c.confidenceScore &&
                isNumber(c.confidenceScore) &&
                Number(c.confidenceScore) < 65)),
        'mid-confidence': isActiveRow
            ? confScore && isNumber(confScore) && Number(confScore) < 80
            : clauseSources.some(c => (c.confidenceScore &&
                isNumber(c.confidenceScore) &&
                Number(c.confidenceScore) < 80)),
    });
    const contentClass = classnames('clause-content', { 'minus-1': clauseSources.length > 1 });
    let subRowIndex = 0;
    const hasNavigation = (clauseSource && isNumber(clauseSource.pageNumber) && clauseSource.coordinates);
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: rowClass, "data-testid": `cell-${cellId}`, onClick: () => !isActiveRow && setSelectedRowIndex(rowIndex) },
            React.createElement("span", { className: 'cell-details-icon', onClick: () => {
                    setIsModalVisible(!isModalVisible);
                    if (isDocModalOpen)
                        setIsDocModalOpen(false);
                }, title: 'Clause Details', "data-testid": `cell-expand-${cellId}`, key: `cell-expand-${cellId}` },
                React.createElement("i", { className: 'fas fa-expand-arrows-alt' })),
            isActiveRow && hasNavigation &&
                React.createElement("span", { className: 'document-navigation-icon', onClick: () => docModalNavigate(), title: 'View in Document', "data-testid": `cell-expand-${cellId}`, key: `cell-expand-${cellId}` },
                    React.createElement("i", { className: 'fas fa-file fa-fw active' })),
            clauseSources.length > 1 && React.createElement(CellTabs, { descriptor: descriptor.key, tabs: clauseSources.map((c, index) => {
                    return {
                        text: `${index + 1} (p ${c.pageNumber || ''})`,
                        confidenceLevel: c.confidenceScore && Number(c.confidenceScore) < 65
                            ? 'low'
                            : c.confidenceScore && Number(c.confidenceScore) < 80
                                ? 'mid'
                                : undefined,
                    };
                }), activeTabIndex: clauseIndex, onTabChange: (selectedIndex) => {
                    setClauseIndex(selectedIndex);
                    if (doc.fileId === anchorDoc.fileId)
                        setAnchorDocTabIndex(Object.assign(Object.assign({}, anchorDocTabIndex), { [descriptor.key]: selectedIndex }));
                } }),
            React.createElement("div", { className: contentClass, "data-testid": `cell-content-${cellId}` }, getCellValueFormatted())),
        React.createElement(DetailsModal, { "data-testid": `cell-single-document-modal-${cellId}`, anchorDoc: anchorDoc, comparisonDoc: doc, descriptor: descriptor, visible: isModalVisible, onHide: () => {
                setIsModalVisible(false);
                setSelectedQuestion(undefined);
            }, formattedCellValue: getModalValueFormatted(), comparisonChecklistItems: clauseSource ? clauseSource.checkList : undefined, clauseSources: clauseSources, clauseSourceIndex: clauseIndex, setClauseSourceIndex: setClauseIndex, checklistQuestion: selectedQuestion }),
        isActiveRow && areChecklistItemsVisible &&
            hasPermission(Permissions.VIEW_COMPARISON_CHECKLIST_ITEMS) &&
            descriptor.subRows.length > 0 &&
            descriptor.subRows.map(checkListClassification => {
                const subCellId = `${cellId}-${subRowIndex}`;
                subRowIndex++;
                return React.createElement("div", { className: 'classification cell active', "data-testid": `cell-${subCellId}`, onClick: () => !isActiveRow && setSelectedRowIndex(rowIndex) },
                    React.createElement("span", { className: 'cell-details-icon', onClick: () => {
                            setSelectedQuestion(checkListClassification.descriptor.key);
                            setIsModalVisible(!isModalVisible);
                        }, title: 'Clause Details', "data-testid": `cell-expand-${cellId}`, key: `cell-expand-${cellId}` },
                        React.createElement("i", { className: 'fas fa-expand-arrows-alt' })),
                    React.createElement("div", { className: 'clause-content', "data-testid": `cell-content-${cellId}` }, checklistValues.cellValueFormatted(checkListClassification, (clauseData === null || clauseData === void 0 ? void 0 : clauseData.checklistItems) || {})));
            }));
};
export default ClauseCell;
